const HttpClient = require('../core/httpClient')

class LoanService {
  constructor(client) {
    this.client = client
  }

  async createLoan(authToken, loanPayload) {
    if (!authToken) {
      throw new Error('El token de autenticación es requerido.')
    }

    const response = await this.client.request('loan', 'POST', loanPayload, authToken)

    return response
  }
}

module.exports = LoanService
